import ICategoryDetail from '@Shared.Angular/@types/core/contracts/queryModel/category/categoryDetail';

const naturalSortCollator = new Intl.Collator('en', {
  numeric: true,
  sensitivity: 'base'
});

function normalizeNaturalSortValue(value: string | null | undefined): string {
  return value ?? '';
}

export function naturalSortComparator(
  leftValue: string | null | undefined,
  rightValue: string | null | undefined
): number {
  return naturalSortCollator.compare(
    normalizeNaturalSortValue(leftValue),
    normalizeNaturalSortValue(rightValue)
  );
}

export function sortCategoriesNaturally(
  categories: ICategoryDetail[]
): ICategoryDetail[] {
  return categories
    .map((category) => ({
      ...category,
      subCategories: category.subCategories
        ? sortCategoriesNaturally(category.subCategories)
        : category.subCategories
    }))
    .sort((leftCategory, rightCategory) =>
      naturalSortComparator(leftCategory.name, rightCategory.name)
    );
}
